// #region IMPORT
import {
  IAuthLoginParams,
  IAuthLoginResponse,
} from "../../../../model/auth/auth.model";
import { Builder, MD } from "../../api.baseQuery";
import { IEndpointTags } from "../../api.endpoint";
// #endregion

// #region INTERFACES
export type AuthEndpoint = {
  login: MD<IAuthLoginParams, IAuthLoginResponse>;
};
// #endregion

// #region ENDPOINT
export const authTagTypes: IEndpointTags<AuthEndpoint> = {
  login: "",
};

export const authEndpoint = (builder: Builder): AuthEndpoint => ({
  login: builder.mutation({
    query: (body) => ({
      url: "auth/maintainers",
      method: "POST",
      body,
    }),
  }),
});
// #endregion
